<template>
  <div class="quiz-player-block">
    <div class="mini-quiz-block get">
      <div class="content_wrapper">
        <div class="assessment-take__quiz__quiz-done">
          <h4>Well Done!</h4>
          <h5>You understand this concept.</h5>
        </div>
      </div>
      <div class="footer_quiz">
        <div class="center-block">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuizPassed",
  props: {
    target: Object
  },
  computed: {
    targetDescription() {
      return this.target.type == "Outline" ? "Concept" : "Tutorial";
    }
  }
};
</script>
